import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import isEmpty from 'lodash/isEmpty'
import uniq from 'lodash/uniq'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import { useShiftsRows } from 'modules/shift_management/hooks/useShiftsRows'
import { useTemplateWeeks } from 'modules/shift_management/hooks/useTemplateWeeks'

import TemplateWeeks from './TemplateWeeks'

const ColorCode = () => {
  const [{ shiftsRows }] = useShiftsRows()
  const [templateWeeks] = useTemplateWeeks()
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false)

  const shiftsInView = useUnsafeMemo(
    () => shiftsRows.flatMap((row) => row.shifts.shifts),
    [shiftsRows]
  )

  const templateWeeksInView = useUnsafeMemo(() => {
    const templateWeeksIdsInView = new Set(uniq(shiftsInView.map((shift) => shift.templateWeekId)))
    return templateWeeks.templateWeeks.filter((templateWeek) =>
      templateWeeksIdsInView.has(templateWeek.id)
    )
  }, [shiftsInView, templateWeeks])

  const showColors = useUnsafeMemo(() => !isEmpty(templateWeeksInView), [templateWeeksInView])

  return (
    <>
      {showColors && (
        <Box onClick={() => setIsModalVisible(true)} style={{ cursor: 'pointer' }}>
          <Text.Normal size="100" weight="bold">
            {i18n.t('shift_management.default_shift.colors.view_color_code')}
          </Text.Normal>
        </Box>
      )}

      {isModalVisible && (
        <Modal
          // TODO: Change for the bucket illustration when available
          illustration="brush-pencil"
          title={i18n.t('shift_management.default_shift.colors.shifts_color_code')}
          onClose={() => setIsModalVisible(false)}
        >
          <Box gap="s24">
            {!!templateWeeksInView.length && <TemplateWeeks templateWeeks={templateWeeksInView} />}
          </Box>
        </Modal>
      )}
    </>
  )
}

export default observer(ColorCode)
